import { useEffect, useState } from 'react';

interface TourVideo {
  videoUrl: string;
  subtitlesUrl?: string;
  isLoading: boolean;
}

export default function useTourVideo(
  tourId?: string,
  videoId?: string,
): TourVideo {
  const [video, setVideo] = useState<TourVideo>({
    videoUrl: '',
    isLoading: true,
  });

  useEffect(() => {
    const fetchData = async () => {
      setVideo({ videoUrl: '', isLoading: true });

      try {
        const response = await fetch(`/api/tour/${tourId}/videos/${videoId}`);

        if (!response.ok) {
          throw new Error('Failed to fetch the data');
        }

        const { videoUrl, subtitlesUrl } = await response.json();

        setVideo({ videoUrl, subtitlesUrl, isLoading: false });
      } catch (error) {
        console.log('The following error has occured: ', error);
        setVideo({ videoUrl: '', isLoading: false });
      }
    };

    fetchData();
  }, [tourId, videoId]);

  return video;
}
